export interface IHudOffer {
	title: string;
	description: string;
	caseId: string;
	timer: number;
	color: string;
}

export enum HudHintType {
	Hospital = 'hospital',
}

export interface IHudHint {
	type: HudHintType;
	timer?: number;
}

export interface IHudPlaytimeReward {
	amount: number;
	expiresAt: number;
	isReceived: boolean;
}
